export const Footer = {
    shops: 'Stores',
    goodsList: 'All Goods',
    aboutUs: 'About Us',
    contactUs: 'Contact us', 
    copyRight: 'all rigths reserved for Hyper Bussiness Group',
}